export default __webpack_public_path__ + "25e2400d06de2726d9475750e9476182.glb";